import angular from 'angular';
import DataErrorComponent from './data-error.component';

const DataErrorModule = angular
    .module('control-room.commons.layout.components.data-error', [])
    .component('crDataError', DataErrorComponent);

export default DataErrorModule;
